import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UpdatingModal } from '../../../../shared';
import { updateOrganization } from '../../../../services/organizations';

const EditOrgModal = ({ open, closeModal, item: org, setMessage, updateTable }) => {
  const [orgInput, setOrgInput] = useState({});
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const { t: translate } = useTranslation();

  const inputChangedHandler = (values) => {
    setOrgInput({ ...orgInput, ...values });
    setDisabled(Object.values(values).some((item) => !item.trim()));
  };

  const handleClose = () => {
    setOrgInput({});
    setDisabled(true);
    setLoading(false);
    closeModal();
  };

  const errorMessage = (error) => {
    const response = error.response || error;
    switch (response.status) {
    case 409:
      setMessage(translate('taxId already in use'));
      break;
    case 403:
      setMessage(translate('permission denied'));
      break;
    default:
      setMessage(translate(`NOT updated org`));
      break;
    }
  };

  const confirmUpdate = async () => {
    setLoading(true);
    setDisabled(true);

    try {
      await updateOrganization({ id: org.id, ...orgInput });
      setMessage(translate(`updated org`));
      updateTable();
    } catch (err) {
      errorMessage(err);
    };
    handleClose();
  };

  return (
    <>
      <UpdatingModal
        openModal={open}
        closeModal={() => handleClose()}
        confirm={() => confirmUpdate()}
        name={translate('update')}
        testid='edit-org-modal'
        textFields={['name', 'taxId', 'owner']}
        inputChangedHandler={inputChangedHandler}
        disabled={disabled}
        loading={loading}
      />
    </>
  );
};

export default EditOrgModal;
